/* Mode scene: same lamp, same room, the light changes. Layers cross-fade; buttons act as a toggle group. */
function initModes(sec) {
  if (sec._laReady) return;
  sec._laReady = true;
  const btns = Array.from(sec.querySelectorAll('[data-la-mode]'));
  const layers = Array.from(sec.querySelectorAll('[data-la-layer]'));
  const desc = sec.querySelector('[data-la-mode-desc]');
  const texts = Object.fromEntries(Array.from(sec.querySelectorAll('[data-la-mode-text]')).map((t) => [t.dataset.laModeText, t.innerHTML.trim()]));
  /* warm the other photos once the scene is near, so the first switch is instant */
  const io = new IntersectionObserver((es) => {
    if (!es.some((e) => e.isIntersecting)) return;
    io.disconnect();
    sec.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
  }, { rootMargin: '400px 0px' });
  io.observe(sec);
  btns.forEach((b) => b.addEventListener('click', () => {
    const k = b.dataset.laMode;
    btns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    layers.forEach((l) => l.classList.toggle('is-on', l.dataset.laLayer === k));
    sec.style.setProperty('--mc', b.dataset.accent);
    if (desc && texts[k] != null) desc.innerHTML = texts[k];
  }));
}
const run = (scope = document) => scope.querySelectorAll('[data-la-modes]').forEach(initModes);
run();
document.addEventListener('shopify:section:load', (e) => run(e.target));
document.addEventListener('shopify:block:select', (e) => {
  const b = e.target.closest && e.target.closest('[data-la-mode]');
  if (b) b.click();
});
